import React from 'react';
import 'pages/Ocf/style/Ocf.scss';
import './WhatsChanged.style.scss';
import { Row as CRow } from 'components/Containers/Row/Row';
import DifferenceTable from 'components/DifferencesTable';
import DifferentialText from 'components/DifferentialText';
import { TotalCreditLimitDecreaseTooltip } from 'pages/Factor/components/WhatsChangedReport/WhatsChangedReport';

export const CreditInfoTable = props => {
  const {
    creditUsage,
    creditLimit,
    creditAge,
    creditInquiries,
    currentAge,
    negativeMarks,
  } = props;
  const { Row, Cell, CellHeader, CellData, Body } = DifferenceTable;
  return (
    <CRow className="rowTable">
      <DifferenceTable datatestid="whats-changed-table">
        <Body>
          <Row>
            <Cell className={'itemVertAlign'}>
              <CellHeader>
                <div className="topCell">Credit Usage</div>
              </CellHeader>
              <CellData datatestid="wc-creditusage-current">
                <span className="padR8 inblock bold">
                  {creditUsage.current}%
                </span>
                <DifferentialText
                  datatestid="creditusage-table-diff"
                  {...creditUsage}
                  fontSizeClass="text-12"
                />
              </CellData>
            </Cell>
            <Cell className={'itemVertAlign'}>
              <CellHeader>
                <div className="topCell">Credit Age</div>
              </CellHeader>
              <CellData datatestid="wc-creditage-current">
                <span className="padR8 inblock bold">{currentAge}</span>
                <DifferentialText
                  datatestid="creditage-table-diff"
                  {...creditAge}
                  fontSizeClass="text-12"
                />
              </CellData>
            </Cell>
            <Cell className={'itemVertAlign'}>
              <CellHeader>
                <div className="topCell">Negative Marks</div>
              </CellHeader>
              <CellData datatestid="wc-creditusage-current">
                <span className="padR8 inblock bold">
                  {negativeMarks.current}
                </span>
                <DifferentialText
                  datatestid="creditusage-table-diff"
                  {...negativeMarks}
                  fontSizeClass="text-12"
                />
              </CellData>
            </Cell>
          </Row>
          <Row>
            <Cell className={'itemVertAlign'}>
              <CellHeader>
                <div className="secTopCell">
                  {creditLimit.difference >= 0 ? (
                    'Total Credit Limit'
                  ) : (
                    <TotalCreditLimitDecreaseTooltip />
                  )}
                </div>
              </CellHeader>
              <CellData datatestid="wc-creditlimit-current">
                <span className="padR8 inblock bold">
                  ${creditLimit.current.toLocaleString()}
                </span>
                <DifferentialText
                  datatestid="creditlimit-table-diff"
                  {...creditLimit}
                  fontSizeClass="text-12"
                />
              </CellData>
            </Cell>
            <Cell className={'itemVertAlign'}>
              <CellHeader>
                <div className="secTopCell">Credit Inquiries</div>
              </CellHeader>
              <CellData datatestid="wc-creditinquiries-current">
                <span className="padR8 inblock bold">
                  {creditInquiries.current}
                </span>
                <DifferentialText
                  datatestid="creditinquiries-table-diff"
                  {...creditInquiries}
                  fontSizeClass="text-12"
                />
              </CellData>
            </Cell>
          </Row>
        </Body>
      </DifferenceTable>
    </CRow>
  );
};
